import { postApiRequestBuilder } from '@/utils/RequestBuilder';

export function updateLpiRating(participantId, rating) {
	return postApiRequestBuilder(
		`admin/participants/${participantId}/rating`,
	).send({ rating });
}
